import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';

export const startupDatadog = (environment: string): void => {
  const rumInitConfig: RumInitConfiguration = {
    applicationId: process.env.REACT_APP_DATA_DOG_APP_ID,
    clientToken: process.env.REACT_APP_DATA_DOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'wolf-athenaeum-webview',
    env: environment,
    version: process.env.REACT_APP_VERSION,
    sampleRate: 10,
    replaySampleRate: 0,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  };

  datadogRum.init(rumInitConfig);
};
